const Slide = ({ attributes, carousel, index, clientId }) => {
	const { elements = { linkNewTab: false, linkOn: 'image' } } = attributes;
	const { image, action = 'none', link = '', caption = '' } = carousel;

	const imgProps = { carousel, action, image, clientId };
	const linkProps = { linkNewTab: elements?.linkNewTab, action, link };

	return <>
		<figure className={`carousel carousel-${index}`}>
			{'image' === elements?.linkOn ? <LinkEl {...linkProps}>
				<ImageEl {...imgProps} />
			</LinkEl> : <ImageEl {...imgProps} />}
		</figure>

		{'caption' === elements?.linkOn ? <LinkEl {...linkProps}>
			<CaptionEl caption={attributes.caption} text={caption} />
		</LinkEl> : <CaptionEl caption={attributes.caption} text={caption} />}
	</>
}
export default Slide;

const ImageEl = ({ carousel, clientId }) => {
	const { image, action = 'none', caption = '' } = carousel;
	const { url = '', alt = '', title = '' } = image || {};

	return url && 'lightbox' === action ? <a data-fancybox={`bicbCarouselGallery-${clientId}`} data-caption={caption} className="fancybox" href={url}>
		<img src={url} alt={alt || title} />
	</a> : <img src={url} alt={alt || title} />
}

const CaptionEl = ({ caption, text }) => {
	const { display = 'none', position = 'onImage' } = caption || {};

	return (text && 'none' !== display) && <div className={`caption display-${display} ${position}`}>
		<p dangerouslySetInnerHTML={{ __html: text }} />
	</div>
}

const LinkEl = ({ linkNewTab, action = 'none', link, children }) => {
	return ('link' === action && link) ? <a href={link} target={linkNewTab ? '_blank' : '_self'} rel='noreferrer'>
		{children}
	</a> : children;
}